// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"366":"36fb36c8","423":"6d2d4afb","840":"9c32790a","883":"d3fd3998"}[chunkId] + ".css";
};